import React from "react";
import { IconBox, PriceBox, NameBox } from "../../../components/molecules";
import viewIcon from "../../../assets/images/view-icon.svg";

export const OrderRow = ({
  noOfItems,
  orderValue,
  orderDeliveryDate,
  orderRef,
  viewOnClick,
}) => {
  return (
      <div className="order-row d-flex gap-5">
        <div className="d-flex flex-wrap gap-3 w-100 spacing">
          <PriceBox topText={"Order Ref"} bottomText={orderRef} />
          <PriceBox
          topText={"Order value"}
          bottomText={`\u00A3${orderValue}`}
          />
          <PriceBox
          topText={"Date of delivery"}
          bottomText={orderDeliveryDate}
          />
          <NameBox name={noOfItems} heading="No. of items" />
        </div>
        <div>
          <IconBox icon={viewIcon} subtitle="View" onClick={viewOnClick} />
        </div>
      </div>
  );
};
